// src/utils/themeUtils.js

import Cookies from 'js-cookie';

// Available themes
const themes = {
  light: 'light',
  dim: 'dim',
  dark: 'dark',
};

// Save theme to cookie
export const saveThemeToCookie = (theme) => {
  Cookies.set('theme', theme, { expires: 30 }); // Save for 30 days
};

// Get theme from cookie
export const getThemeFromCookie = () => {
  const theme = Cookies.get('theme');
  return theme || themes.light; // Default to light theme
};

// Apply theme to document
export const applyTheme = (theme) => {
  document.documentElement.setAttribute('data-theme', theme);
};
